module.exports = __webpack_public_path__ + "static/media/telegram.4a4f582c.jpg";